import { render } from "./crossRecorders.vue?vue&type=template&id=535a34fe&scoped=true&lang=pug"
import script from "./crossRecorders.vue?vue&type=script&setup=true&lang=js"
export * from "./crossRecorders.vue?vue&type=script&setup=true&lang=js"

import "./crossRecorders.vue?vue&type=style&index=0&id=535a34fe&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a34fe"]])

export default __exports__